// extracted by mini-css-extract-plugin
export default {"header":"NewProject_tsx_header__O-neP","body":"NewProject_tsx_body__SpkhW","footer":"NewProject_tsx_footer__nADgY","dialog":"NewProject_tsx_dialog__814wU"};